// src/pages/HackathonListPage.tsx
import HackathonList from "../../components/Hackathons/HackathonListPage";

export default function HackathonListPage() {
  return <HackathonList />;
}